import { render, staticRenderFns } from "./screenVideo.vue?vue&type=template&id=6eec3429&scoped=true&"
import script from "./screenVideo.vue?vue&type=script&lang=js&"
export * from "./screenVideo.vue?vue&type=script&lang=js&"
import style0 from "./screenVideo.vue?vue&type=style&index=0&id=6eec3429&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec3429",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eec3429')) {
      api.createRecord('6eec3429', component.options)
    } else {
      api.reload('6eec3429', component.options)
    }
    module.hot.accept("./screenVideo.vue?vue&type=template&id=6eec3429&scoped=true&", function () {
      api.rerender('6eec3429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/screenVideo.vue"
export default component.exports